import { useEffect, useMemo } from 'react';
import { includes } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';
import { useSelector } from 'react-redux';

import { hasPermissionByIds } from '@gef-ui/cdu-user/selectors';

import { USER_ROLES } from 'constants/general';
import { DISPLAY_SUMMARY_OVERVIEW, DISPLAY_SUMMARY_OVERVIEW_MANAGER } from 'features/common/acl/constants';
import { EVENT } from 'features/common/gtm/constants';
import { useDataLayer } from 'features/common/gtm/hooks';
import { getCurrentRole } from 'features/views/user/selectors';
import { getRoutePath } from 'utils';

export const useUserInfoDataLayer = (cduUser) => {
	const handleDataLayer = useDataLayer({ event: EVENT.userInfo });

	useEffect(() => {
		handleDataLayer({
			login_id: cduUser.userNameAd,
			entitlement_type: cduUser.permissions,
			user_type: cduUser.cduUserTypeDescription,
			job_title: cduUser.professionDescription,
			user_team: cduUser.organizationStructure,
		})();
	}, [handleDataLayer, cduUser]);
};

export const useDefaultRedirect = () => {
	const currentRole = useSelector(getCurrentRole);

	const hasDashboardSellerOrPpzPermission = useSelector((state) =>
		hasPermissionByIds(state)(DISPLAY_SUMMARY_OVERVIEW),
	);
	const hasDashboardManagerPermission = useSelector((state) =>
		hasPermissionByIds(state)(DISPLAY_SUMMARY_OVERVIEW_MANAGER),
	);

	const isSellerOrPpzWithDashboardPerm =
		(includes(currentRole, [USER_ROLES.SELLER, USER_ROLES.PPZ]) || isNilOrEmpty(currentRole)) &&
		hasDashboardSellerOrPpzPermission;
	const isManagerWithDashboardPerm = currentRole === USER_ROLES.GROUP_MANAGER && hasDashboardManagerPermission;

	return useMemo(() => {
		if (isSellerOrPpzWithDashboardPerm || isManagerWithDashboardPerm) {
			return getRoutePath('dashboard');
		} else if (!isNilOrEmpty(currentRole)) {
			return getRoutePath('campaigns');
		} else {
			return getRoutePath('tasks');
		}
	}, [isSellerOrPpzWithDashboardPerm, isManagerWithDashboardPerm, currentRole]);
};
